package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import org.moxultimate.topwithmox.apps.data.AppsResponse
import org.moxultimate.topwithmox.appscrud.update.AppsUpdatePage
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.navigation.NavParams

@InitRoute
fun initAppsUpdateRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Edit App"))

    val urlParams: dynamic = js("new URLSearchParams(window.location.search)")
    fun param(key: String): String = (urlParams.get(key) as? String).orEmpty()

    val appsResponse = AppsResponse(
        id          = param(NavParams.ID).toLongOrNull() ?: 0L,
        title       = param(NavParams.TITLE),
        type        = param(NavParams.TYPE),
        description = param(NavParams.DESCRIPTION),
        imagePath   = param(NavParams.IMAGE_PATH),
        videoLink   = param(NavParams.VIDEO_LINK),
        tags        = param(NavParams.TAGS).ifEmpty { null },
    )
    ctx.data.add(appsResponse)
}

@Page(routeOverride = "appsupdate")
@Layout(".components.layouts.PageLayout")
@Composable
fun AppsUpdateRoute() {
    val ctx = rememberPageContext()
    val appsResponse = ctx.data.getValue<AppsResponse>()
    AppsUpdatePage(app = appsResponse)
}
